<template>
  <div class="hzc-price-index">
    <div class="back">当前位置：<span @click="back('/steel')">钢铁</span> > <span
        @click="back('/steel/twoPage/yield')">产量</span> > 正文
    </div>
    <DetailTitle style="margin-bottom: 20px;" :title="time + (flag === 'issue_steel_varieties_yield'? '五大品种合计产量': '粗钢/生铁/钢材产量分省')"></DetailTitle>
<!--    <div class="tabs">-->
<!--      <div v-for="(item, index) in typeList" :key="index" :class="{'active':item.id===num}" @click="num = item.id">{{ item.title }}</div>-->
<!--    </div>-->
    <div class="first" v-if="flag === 'issue_steel_varieties_yield'">
      <YieldDetailTabsOne></YieldDetailTabsOne>
    </div>
    <div class="first" v-if="flag === 'issue_steel_group_province'">
      <YieldDetailTabsTwo></YieldDetailTabsTwo>
    </div>
    <div class="three" v-if="num === 3">
      <YieldDetailTabsThree></YieldDetailTabsThree>
    </div>
    <div class="three" v-if="num === 4">
      <YieldDetailTabsFour></YieldDetailTabsFour>
    </div>
  </div>
</template>

<script>
import DetailTitle from '@/components/common/detatilTitle'
import YieldDetailTabsOne from  '@/components/steel/detail/yieldDetailTabsOne'
import YieldDetailTabsTwo from  '@/components/steel/detail/yieldDetailTabsTwo'
import YieldDetailTabsThree from  '@/components/steel/detail/yieldDetailTabsThree'
import YieldDetailTabsFour from  '@/components/steel/detail/yieldDetailTabsFour'

export default {
  name: "priceIndex",
  components: {
    DetailTitle,
    YieldDetailTabsOne,
    YieldDetailTabsTwo,
    YieldDetailTabsThree,
    YieldDetailTabsFour
  },
  data() {
    return {
      typeList: [{title:'五大品种合计产量',id:1}, {title:'粗钢/生铁产量分省',id:2}, {title:'中钢协产量',id:3},{title:'国际产量',id:4}],
      num:1,
      time:'',
      flag:''
    }
  },
  created() {
    this.flag = this.$route.query.flag;
    this.time = this.$route.query.id;
  },
  methods:{
    /**
     * 返回
     * @param url
     */
    back(url) {
      this.$router.push({path:url, query:{flag:this.flag}});
    },
  }
}
</script>

<style scoped lang="less">
.active {
  background-color: #D3131A !important;
  color:#FFF;
  border:none !important;
}
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;

  .tabs {
    margin: 15px 0;

    div {
      display: inline-block;
      margin-right: 16px;
      padding:0 10px;
      height: 36px;
      background: #F2F2F2;
      border-radius: 4px;
      border: 1px solid #CCCCCC;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }

    div:hover {
      background-color: #D3131A;
      color: #fff;
    }
  }
}
.back {
  span {
    cursor: pointer;
  }
}
</style>
